import getConversationReadingPaneViewState, {
    getCurrentRenderedConversationId,
} from '../utils/getConversationReadingPaneViewState';
import { isReadingPaneStackedView } from 'owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils';
import type { TeamsIntegrationViewState } from '../store/schema/TeamsIntegrationViewState';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { getSelectedTableView } from 'owa-mail-list-store';
import isNewestOnBottom from 'owa-mail-store/lib/utils/isNewestOnBottom';
import getItemReadingPaneViewState from '../utils/getItemReadingPaneViewState';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';

export function getTeamsIntegrationViewState(
    item: ClientItem | undefined
): TeamsIntegrationViewState | undefined {
    if (isReadingPaneStackedView(getSelectedTableView()?.tableQuery?.listViewType)) {
        const currentConversationId =
            item?.ConversationId?.Id ?? getCurrentRenderedConversationId();
        return getTeamsIntegrationViewStateFromConversation(currentConversationId);
    } else {
        return getTeamsIntegrationViewStateFromItem(item?.ItemId?.Id);
    }
}

function getTeamsIntegrationViewStateFromConversation(
    currentConversationId: string
): TeamsIntegrationViewState | undefined {
    const conversationItemParts = getMailStore().conversations.get(currentConversationId);
    const conversationNodeIds = conversationItemParts?.conversationNodeIds;

    if (conversationNodeIds) {
        const conversationReadingPaneState =
            getConversationReadingPaneViewState(currentConversationId);
        const itemPartsMap = conversationReadingPaneState?.itemPartsMap;
        const indexOfFirstItem = isNewestOnBottom() ? 0 : conversationNodeIds.length - 1;

        const itemPart = itemPartsMap?.get(conversationNodeIds[indexOfFirstItem]);
        return itemPart?.teamsIntegrationViewState;
    }
    return undefined;
}

function getTeamsIntegrationViewStateFromItem(
    itemId: string | undefined
): TeamsIntegrationViewState | undefined {
    return getItemReadingPaneViewState(itemId)?.itemViewState?.teamsIntegrationViewState;
}
